var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({
    theme: 'wika light tooltip',
    interactive: true,
    reactive: true,
    placement: 'top',
    flip: false,
    animation: 'perspective',
    animateFill: false,
    arrow: true,
    zIndex: 10000,
    html: '#downloadButtonLinks-' + _vm.id,
    trigger: _vm.isMobileDevice ? 'click' : 'mouseenter focus'
  }),expression:"{\n    theme: 'wika light tooltip',\n    interactive: true,\n    reactive: true,\n    placement: 'top',\n    flip: false,\n    animation: 'perspective',\n    animateFill: false,\n    arrow: true,\n    zIndex: 10000,\n    html: '#downloadButtonLinks-' + id,\n    trigger: isMobileDevice ? 'click' : 'mouseenter focus'\n  }"}],ref:"tippy",class:_vm.$style.container,on:{"init":_vm.initTippy,"show":_vm.forceRerender}},[_c('Button',{attrs:{"colour":_vm.colour,"text":this.config.metadata.fileType && this.config.metadata.fileSize
        ? ((this.config.metadata.fileType) + " (" + (this.config.metadata.fileSize) + ")")
        : _vm.config.title,"isLink":"","href":"#"}}),(_vm.config.urls.url)?_c('ul',{class:_vm.$style.downloadLinks,attrs:{"id":'downloadButtonLinks-' + _vm.id}},[_c('li',[_c('WishListLink',{key:("key-" + _vm.componentKey),attrs:{"config":{
          text: _vm.labels.wishlist,
          item: {
            downloads: [
              {
                url: _vm.config.urls.url,
                flag: _vm.config.urls.flag,
                language: _vm.config.urls.language
              }
            ],
            section: _vm.section,
            title: _vm.config.wishlistTitle,
            types: _vm.config.types
          }
        }}})],1),_c('li',[_c('a',{attrs:{"href":_vm.config.urls.url,"target":"_blank"},on:{"click":function($event){_vm.wtParams &&
            _vm.wtTrack(
              { cat: _vm.wtParams.doctype },
              Object.assign({}, _vm.wtParams,
                {filename: _vm.config.urls.url})
            )}}},[_c('i',{staticClass:"fas fa-file-alt"}),_c('span',[_vm._v(_vm._s(_vm.config.urls.url.split(/\.(?=[^\.]+$)/)[1]))])])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }